import { Injectable } from '@angular/core';
import { ASidebarBuilder } from './a-sidebar-builder';
import { UserInfo } from '../../../../shared/models/auth/user-info.model';
import { SidebarMenuItem } from '../models/sidebar-menu-item.model';
import { SidebarMenuContainer } from '../models/sidebar-menu-container.model';

@Injectable()
export class MtSidebarBuilder extends ASidebarBuilder {
  protected rebuildProgramMenu(userInfo: UserInfo): void {
    const content = new Array<SidebarMenuItem | SidebarMenuContainer>();

    if (userInfo.CurrentProgramId !== null) {
      if (userInfo.IsTrainee && !userInfo.IsSiteAdmin && !userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            name: 'Dashboard',
            icon: 'dashboard',
            isActive: this.routeHelper.dashboardActive.bind(this.routeHelper),
            action: this.routeHelper.dashboard.bind(this.routeHelper, userInfo.CurrentProgramRoleId)
          })
        );
      }

      if (!userInfo.IsTrainee || userInfo.IsSiteAdmin || userInfo.IsSysAdmin || userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            icon: 'users',
            name: 'Users',
            isActive: this.routeHelper.programUsersListActive.bind(this.routeHelper),
            action: this.routeHelper.programUsersList.bind(this.routeHelper)
          })
        );
      }

      if (userInfo.IsSysAdmin || userInfo.IsSiteAdmin || userInfo.IsCoordinator || userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            icon: 'signal',
            name: 'Reports',
            isActive: this.routeHelper.mtReportsActive.bind(this.routeHelper),
            action: this.routeHelper.mtReports.bind(this.routeHelper)
          })
        );
      }

      content.push(
        new SidebarMenuItem({
          icon: 'file',
          name: 'Resources',
          isActive: this.routeHelper.resourcesActive.bind(this.routeHelper),
          action: this.routeHelper.resources.bind(this.routeHelper)
        })
      );
    }

    this.programMenuContent = content;
  }

  protected rebuildProgramSettingsMenu(
    _userInfo: UserInfo,
    _content: Array<SidebarMenuItem | SidebarMenuContainer>
  ): void {}
}
